import { Dispatch, SetStateAction, useEffect } from 'react';
import Checkbox from '@components/common/checkbox';
import { useApplicationPositionList } from '@repository/match';
import ResponsiveModal from '@components/_atoms/ResponsiveModal';
import MatchingHomePositionCardVO from '@domain/vo/match/ApplicationPositionVO';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface ItemProps {
  data: MatchingHomePositionCardVO;
  onClick: (sn: number) => void;
  isChecked: boolean;
}

const Item = ({ data, onClick, isChecked }: ItemProps) => {
  return (
    <button className={cx('itemWrapper')} onClick={() => onClick(data.positionSn)}>
      <div className={cx('column', 'column1')}>
        <Checkbox
          className={cx('checkBox')}
          checked={isChecked}
          margin={'0px'}
          onClick={() => onClick(data.positionSn)}
        />
      </div>
      <div className={cx('column', 'column2')}>
        {data.applicationCompleteTime ? DateFormat.format(new Date(data.applicationCompleteTime), 'yyyy.MM.dd') : '-'}
      </div>
      <div className={cx('column', 'column3')}>{data.companyName}</div>
      <div className={cx('column', 'column4')}>{data.applyStatus}</div>
    </button>
  );
};

interface Props {
  selectSns: number[];
  setSelectSns: Dispatch<SetStateAction<number[]>>;
}

const ApplyList = ({ selectSns, setSelectSns }: Props) => {
  const { data } = useApplicationPositionList('ALL');

  const onClickCheckBox = (sn: number) => {
    setSelectSns((prev: number[]) => {
      const index = prev.indexOf(sn);
      if (index === -1) return [...prev, sn];
      return prev.filter((item) => item !== sn);
    });
  };

  const itemEls = data?.map((item) => {
    return (
      <Item
        key={item.positionSn}
        data={item}
        onClick={onClickCheckBox}
        isChecked={selectSns?.includes(item.positionSn)}
      />
    );
  });
  const allPositionSns = data?.map((item) => item.positionSn) ?? [];

  const onClickAllCheckBox = () => {
    setSelectSns((prev: number[]) => {
      if (prev.length === allPositionSns.length) return [];
      return allPositionSns;
    });
  };

  useEffect(() => {
    if (!data) return;
    setSelectSns(allPositionSns);
  }, [data]);

  return (
    <div>
      <div className={cx('labelArea')}>
        <div className={cx('column', 'column1')}>
          <Checkbox
            checked={selectSns.length === allPositionSns.length}
            className={cx('checkBox')}
            margin={'0px'}
            onClick={onClickAllCheckBox}
          />
        </div>
        <div className={cx('column', 'column2')}>지원일</div>
        <div className={cx('column', 'column3')}>기업명</div>
        <div className={cx('column', 'column4')}>진행 상태</div>
      </div>
      <ResponsiveModal.ScrollArea className={cx('scrollArea')} maxHeight={655}>
        {itemEls}
      </ResponsiveModal.ScrollArea>
    </div>
  );
};

export default ApplyList;
